module.exports = __webpack_public_path__ + "static/media/tyre-red-two4.32c41295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-two4.png
// module id = 346
// module chunks = 0